import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { datesHelper } from "@/shared/utils";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type RouteDetailsByTripDateInput,
  routeDetailsByTripDateInputSchema,
} from "./shared/routeDetails.input";
import {
  type RouteDetail,
  routeDetailSchema,
} from "./shared/routeDetails.output";

/**
 * Metadata for the fetchRouteDetailsByTripDate endpoint
 */
export const routeDetailsByTripDateMeta = {
  functionName: "fetchRouteDetailsByTripDate",
  endpoint: "/routedetails/{TripDate}",
  inputSchema: routeDetailsByTripDateInputSchema,
  outputSchema: routeDetailSchema.array(),
  sampleParams: { TripDate: datesHelper.tomorrow() },
  endpointDescription:
    "List detailed route information for all routes on specified date.",
} satisfies EndpointMeta<RouteDetailsByTripDateInput, RouteDetail[]>;

/**
 * Fetch function for retrieving detailed route information for all routes on specified date
 */
const { fetch, useHook } = createFetchAndHook<
  RouteDetailsByTripDateInput,
  RouteDetail[]
>({
  api: wsfScheduleApiMeta,
  endpoint: routeDetailsByTripDateMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/routeDetails.endpoints").routeDetailsGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving detailed route information for all routes on specified date
 */
export const fetchRouteDetailsByTripDate: FetchFactory<
  RouteDetailsByTripDateInput,
  RouteDetail[]
> = fetch;

/**
 * React Query hook for retrieving detailed route information for all routes on specified date
 */
export const useRouteDetailsByTripDate: HookFactory<
  RouteDetailsByTripDateInput,
  RouteDetail[]
> = useHook;
